module.exports = __webpack_public_path__ + "img/yam_no.9e02c86b.png";